import Container from 'typedi';
import IHTTPClientAdapter from '../adapters/HTTPClientAdapter/IHTTPClientAdapter';
import AxiosAdapter from '../adapters/HTTPClientAdapter/AxiosAdapter';

const setDefaultAdapters = () => {
  Container.set({ id: IHTTPClientAdapter, type: AxiosAdapter });
};

const setEnvironmentVariables = () => {
  Container.set({
    id: 'ENV_CORE_API_URL',
    value: process.env.VUE_APP_CORE_API_URL || 'https://api-dev.waypoint.cl/core',
  });
  Container.set({
    id: 'ENV_LASTMILE_API_URL',
    value: process.env.VUE_APP_API_URL || 'https://api-dev.waypoint.cl/lastmile',
  });
  Container.set({
    id: 'ENV_API_URL',
    value: process.env.VUE_APP_IMAGE_URL || 'https://api-dev.waypoint.cl',
  });
};

const setDefaults = () => {
  setDefaultAdapters();
  setEnvironmentVariables();
};

export { setDefaultAdapters, setEnvironmentVariables, setDefaults };
